var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-link",
    {
      staticClass: "task",
      attrs: { to: "/tasks/" + _vm.value.FolderID + "/" + _vm.value.ID },
    },
    [
      _vm.hasUnread ? _c("div", { staticClass: "notification-dot" }) : _vm._e(),
      _c(
        "w-row",
        [
          _vm.value.TimeStamp.getTime() > 0
            ? _c("app-timeago", {
                staticClass: "timestamp",
                attrs: { datetime: _vm.value.TimeStamp },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" " + _vm._s(_vm.value.Text) + " "),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }